<div class="org-list-container">
    <div class="org-list-container-inner">
        <pworg-list *ngFor="let orgList of orgTree" 
                  [orgList]="orgList" 
                  (orgAdded)="onOrgAdd($event)" 
                  (orgCollapsed)="onOrgCollapsed($event)" 
                  (orgExpanded)="onOrgExpanded($event)"></pworg-list>
    </div>
</div>